class HeaderSearchOverlay {
  constructor() {
    this.overlay = document.querySelector('[data-header-search-overlay]');
    this.panel = this.overlay?.querySelector('[data-header-search-panel]');
    this.form = this.overlay?.querySelector('[data-header-search-form]');
    this.input = this.overlay?.querySelector('[data-header-search-input]');
    this.buttons = Array.from(document.querySelectorAll('.thb-quick-search'));
    this.submitTimer = null;

    if (!this.overlay || !this.panel || !this.form || !this.input || !this.buttons.length) return;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.overlay.hidden ? this.open() : this.close();
      });
    });

    this.overlay.addEventListener('click', (event) => {
      if (!this.panel.contains(event.target)) this.close();
    });

    this.form.addEventListener('submit', (event) => {
      if (!this.getQuery()) event.preventDefault();
    });

    this.input.addEventListener('input', () => {
      window.clearTimeout(this.submitTimer);
      const query = this.getQuery();
      if (!query) return;

      this.submitTimer = window.setTimeout(() => {
        if (this.getQuery()) this.form.requestSubmit();
      }, 700);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.overlay.hidden) this.close();
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  open() {
    const visibleButton = this.buttons.find((button) => button.offsetParent !== null);
    const header = visibleButton?.closest('nav') || visibleButton?.closest('header') || visibleButton?.closest('.shopify-section');
    const ssHeader = visibleButton?.closest('[data-ss-header]');
    this.activeSsHeader = ssHeader?.classList.contains('transparent') ? ssHeader : null;
    if (this.activeSsHeader) this.activeSsHeader.classList.add('search-open', 'onscroll');
    if (header) this.overlay.style.top = `${header.getBoundingClientRect().bottom}px`;
    this.overlay.hidden = false;
    document.body.classList.add('header-search-open');
    this.buttons.forEach((button) => {
      button.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      const label = button.querySelector('[data-search-toggle-label]');
      if (label) label.textContent = 'Close';
    });
    window.setTimeout(() => this.input.focus({ preventScroll: true }), 0);
    document.dispatchEvent(new CustomEvent('search:open'));
  }

  close() {
    window.clearTimeout(this.submitTimer);
    this.overlay.hidden = true;
    document.body.classList.remove('header-search-open');
    if (this.activeSsHeader) {
      this.activeSsHeader.classList.remove('search-open');
      if (window.scrollY === 0) this.activeSsHeader.classList.remove('onscroll');
      this.activeSsHeader = null;
    }
    this.buttons.forEach((button) => {
      button.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      const label = button.querySelector('[data-search-toggle-label]');
      if (label) label.textContent = 'Search';
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new HeaderSearchOverlay();
});
